import React, {
  memo,
  useMemo
} from "react";
import {
  StyleSheet
} from "react-native";
import {
  YStack,
  XStack
} from "tamagui";
import {
  Card,
  Title,
  Text
} from "@constants/Themed";
import ModernChartWrapper from "@components/Charts/ModernChartWrapper";
import {
  MaterialIcons,
  AntDesign
} from "@expo/vector-icons";
import {
  MODERN_CHART_COLORS
} from "@utils/chartTheme";
import {
  themeSelector
} from "@reduxLocal/selectors/themeSelector";
import {
  useTranslation
} from "react-i18next";

interface SubscriptionWidgetProps {
  subscriptionData: {
    product?: {
      toString: () => string;
    };
  } | null;
}

const SubscriptionWidget: React.FC<SubscriptionWidgetProps> = ({
  subscriptionData,
}) => {
  const theme = themeSelector();
  const {
    t
  } = useTranslation();

  const summaryData = useMemo(() => {
    if (!subscriptionData) {
      return [];
    }
    return [{
      label: "Plan",
      value: subscriptionData?.product?.toString() || "Basic",
      color: MODERN_CHART_COLORS.line.primary,
    }, {
      label: "Status",
      value: "Active",
      color: MODERN_CHART_COLORS.line.secondary,
    }, {
      label: "Renewal",
      value: "Auto",
      color: MODERN_CHART_COLORS.line.tertiary,
    },];
  }, [subscriptionData]);

  if (!subscriptionData) {
    return (<
      Card style={
        styles.cardBase
      } >
      <
      Title > {
          t("Subscription Status")
        } < /Title> <
      Text > {
            t("No subscription data available")
          } < /Text> <
      /Card>
          );
  }

          return ( <
    ModernChartWrapper title="Subscription Status"
            subtitle="Your current plan and billing information"
            summaryData={
              summaryData
            } >
            <
    XStack justifyContent="center"
              alignItems="center"
              gap={
                15
              }
              style={
                styles.container
              } >
              <
    YStack alignItems="center" >
                <
                  MaterialIcons name="verified"
                  size={
                    32
                  }
                  color="#4CAF50" />
                <
    Text style={
                    [styles.text, {
                      color: theme ? "#000" : "#fff"
                    }]
                  } > {
                    subscriptionData?.product?.toString() || "Basic Plan"
                  } <
    /Text> <
    /YStack> <
    YStack alignItems="center" >
                    <
                      AntDesign name="clockcircle"
                      size={
                        32
                      }
                      color="#2196F3" />
                    <
    Text style={
                        [styles.subText, {
                          color: theme ? "#666" : "#aaa"
                        }]
                      } >
                      Active Since <
    /Text> <
    /YStack> <
    /XStack> <
    /ModernChartWrapper>
                      );
};

                      const styles = StyleSheet.create({
                        cardBase: {
                        width: "100%",
                      height: "100%",
                      borderRadius: 15,
                      overflow: "hidden",
                      padding: 16,
                      justifyContent: "center",
                      alignItems: "center",
                      flex: 1,
  },
                      container: {
                        marginTop: 20,
  },
                      text: {
                        marginTop: 5,
                      fontSize: 14,
  },
                      subText: {
                        marginTop: 5,
                      fontSize: 12,
  },
});

                      export default memo(SubscriptionWidget);
